import React, { useCallback, useMemo } from 'react';
import { sendEvents } from '@fiverr-private/futile';
import { bigQuery } from '@fiverr-private/obs';

const getBigQueryData = (headerType, linkKey) => ({
    group: 'header_clicks',
    type: `clicked_header.${linkKey}`,
    header_type: headerType,
});

export const reportBigQuery = (...params) => {
    const event = getBigQueryData(...params);

    if (typeof Fiverr === 'object' && typeof window.Fiverr.sendClientEvents === 'function') {
        sendEvents(event);
    } else {
        bigQuery.send(event);
    }
};

export const EventsReportApiContext = React.createContext(null);
export const useEventsContext = ({ headerType }) => {
    const reportBQ = useCallback((linkKey) => reportBigQuery(headerType, linkKey), [headerType]);
    const eventsApi = useMemo(() => ({ reportBQ }), [reportBQ]);

    return { EventsReportApiContext, eventsApi };
};
